import { ClientApi } from '@ssv-website/hooks';
import type {
  ConferenceApiResponse,
  ConferenceGuestDetail,
  ConferenceRegisterPayload,
  ConferenceRegisterResult,
  ConferenceGuestUpdateResult,
} from './types';

const CONFERENCE_GUEST_API_PREFIX = '/openTechPortalWebAPI/techforgood/guest';
const CONFERENCE_GUEST_DETAIL_API =
  `${CONFERENCE_GUEST_API_PREFIX}/detail`;
const CONFERENCE_REGISTER_API_PREFIX =
  '/openTechPortalWebAPI/techforgood/conference';

export const CONFERENCE_DUPLICATE_REGISTER_MESSAGE = '您已报名，请勿重复提交';

export const getConferenceGuestDetail = () =>
  ClientApi.get<ConferenceApiResponse<ConferenceGuestDetail>>(
    CONFERENCE_GUEST_DETAIL_API,
    {
      cache: 'no-store',
      errorMessage: false,
    }
  );

export const registerConference2026 = (payload: ConferenceRegisterPayload) =>
  ClientApi.post(
    `${CONFERENCE_REGISTER_API_PREFIX}/2026/register`,
    payload
  ) as Promise<ConferenceRegisterResult>;

export const updateConferenceGuest = (payload: ConferenceRegisterPayload) =>
  ClientApi.post(
    `${CONFERENCE_GUEST_API_PREFIX}/update`,
    payload
  ) as Promise<ConferenceGuestUpdateResult>;
